import { useState } from "react";
import Banner from "./components/Banner";
import Main from "./components/Main";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import VehicleBrands from "./components/Vehicle_Details/VehicleBrands";
import VehicleSeries from "./components/Vehicle_Details/VehicleSeries";
import VehicleModels from "./components/Vehicle_Details/VehicleModels";
import VehicleEngines from "./components/Vehicle_Details/VehicleEngines";
import VehicleChipTuning from "./components/Vehicle_Details/VehicleChipTuning";

import "./App.css";
import bannerImage from "../src/assets/images/banner-bg.jpg";

if (!window.DEFAULT_IMAGE_URL) {
  window.DEFAULT_IMAGE_URL = "https://placehold.co/100";
}

function App() {
  const [changeBanner, setChangeBanner] = useState(false);
  const baseUrl = window.REACT_APP_BASE_URL || '';

  return (
    <Router basename={baseUrl}>
      {!changeBanner && (
        <main className="App">
          <div className="w-full bg-center" style={{ backgroundImage: `url(${bannerImage})` }}>
            <div className="w-full bg-black opacity-60 text-white">
              <Banner />
            </div>
          </div>
        </main>
      )}
      <Routes>
        <Route path="/:vehicleBrandId" element={<VehicleBrands changeBanner={setChangeBanner} />} />
        <Route path="/:vehicleBrandId/:vehicleSeriesId" element={<VehicleSeries changeBanner={setChangeBanner} />} />
        <Route path="/:vehicleBrandId/:vehicleSeriesId/:vehicleModelId" element={<VehicleModels changeBanner={setChangeBanner} />} />
        <Route path="/:vehicleBrandId/:vehicleSeriesId/:vehicleModelId/:vehicleEngineId" element={<VehicleEngines changeBanner={setChangeBanner} />} />
        <Route path="/:vehicleBrandId/:vehicleSeriesId/:vehicleModelId/:vehicleEngineId/:vehicleChipTuningId" element={<VehicleChipTuning changeBanner={setChangeBanner} />} />

        <Route path="/" element={<Main changeBanner={setChangeBanner} />} />
      </Routes>
    </Router>
  );
}

export default App;
